import React from 'react';
import { Table } from 'antd';
import { useSelector } from 'react-redux';
import '../../css/pdf.css';

const SailingMonitor = () => {
    const { statementDocument } = useSelector((state) => state.voyage);
    const { consumptions = [] } = statementDocument || {};

    const columns = [
        // {
        //     title: 'Fuel No.',
        //     dataIndex: 'fuelNumber',
        //     key: 'fuelNumber',
        // },
        {
            title: 'Fuel Type',
            dataIndex: 'fuel_name',
            key: 'fuel_name',
        },
        {
            title: 'Fuel Consumption (MT)',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (value) => value.toFixed(2),
        },
        {
            title: 'CO₂ Emitted (MT)',
            dataIndex: 'co2_emitted',
            key: 'co2_emitted',
            render: (value) => value.toFixed(2),
        },
        {
            title: 'CH4 Emitted (MT)',
            dataIndex: 'ch4_emitted',
            key: 'ch4_emitted',
            render: (value) => value.toFixed(2),
        },
        {
            title: 'N₂O Emitted (MT)',
            dataIndex: 'n2o_emitted',
            key: 'n2o_emitted',
            render: (value) => value.toFixed(2),
        },
        {
            title: 'CO₂ Eq (MT)',
            dataIndex: 'co2_equivalent',
            key: 'co2_equivalent',
            render: (value) => value.toFixed(2),
        },
        
    ];

    const dataSource = consumptions?.map((item, index) => ({
        key: index + 1,
        fuelNumber: index + 1,
        ...item,
    }));

    const totalQuantity = consumptions.reduce((sum, item) => sum + item.quantity, 0);
    const totalN2OEmitted = consumptions.reduce((sum, item) => sum + item.n2o_emitted, 0);
    const totalCH4Emitted = consumptions.reduce((sum, item) => sum + item.ch4_emitted, 0);
    const totalCO2Emitted = consumptions.reduce((sum, item) => sum + item.co2_emitted, 0);
    const totalCO2Eq = consumptions.reduce((sum, item) => sum + item.co2_equivalent, 0);

    const expandedRowRender = () => (<>
        <tr className="ant-table-row">
            <td colSpan={1} className="ant-table-cell">Total</td>
            <td className="ant-table-cell">{totalQuantity?.toFixed(2)}</td>
            {/* <td className="ant-table-cell">{totalEfForCO2?.toFixed(2)}</td> */}
            <td className="ant-table-cell">{totalCO2Emitted?.toFixed(2)}</td>
            <td className="ant-table-cell">{totalCH4Emitted?.toFixed(2)}</td>
            <td className="ant-table-cell">{totalN2OEmitted?.toFixed(2)}</td>
            <td className="ant-table-cell">{totalCO2Eq?.toFixed(2)}</td>
        </tr>
        <tr className="ant-table-row">
            <td colSpan={1} className="ant-table-cell sb-background">EUA</td>
            <td className="ant-table-cell">{statementDocument?.vessel_particulars?.eua_total?.toFixed(3)}</td>
            <td className="ant-table-cell sb-background">Voyage Status</td>
            <td colSpan={3} className="ant-table-cell">{statementDocument?.vessel_particulars?.voyage_status}</td>
        </tr></>
    );

    return (
        <Table
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            bordered
            components={{
                header: {
                    wrapper: ({ children, ...props }) => (
                        <thead {...props} className="sb-background">
                            {children}
                        </thead>
                    ),
                },
                body: {
                    wrapper: ({ children, ...props }) => (
                        <tbody {...props}>
                            {children}
                            {expandedRowRender()}
                        </tbody>
                    ),
                },
            }}
        />
    );
};

export default SailingMonitor;
